import { supabase } from "../supabaseClient";

async function addNote(noteData, userId, leadId) {
  const { data, error } = await supabase.from("leadNotes").insert([
    {
      noteType: noteData.noteType,
      callType: noteData.type,
      title: noteData.title,
      description: noteData.description,
      userId: userId,
      leadId: leadId,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function getNotes(leadId, userId, from, to) {
  const { data, count, error } = await supabase
    .from("leadNotes")
    .select("*", { count: "exact" })
    .eq("leadId", leadId)
    .eq("userId", userId)
    .range(from, to)
    .order("last_updated_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}
async function getLeadStatus(leadId) {
  const { data, count, error } = await supabase
    .from("LeadLogs")
    .select("*,userId(*),cpId(*),fosId(*)")
    .eq("leadId", leadId)
    .order("last_updated_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}

async function addCrmNote(noteData, allotmentPaymentid, crmuserid) {
  const { data, error } = await supabase.from("CRMNotes").insert([
    {
      noteType: noteData.noteType,
      callType: noteData.type,
      title: noteData.title,
      description: noteData.description,
      allotmentPaymentId: allotmentPaymentid,
      crmUserId: crmuserid,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function getCrmNotes(allotmentPaymentId, crmuserid, from, to) {
  const { data, count, error } = await supabase
    .from("CRMNotes")
    .select("*", { count: "exact" })
    .eq("allotmentPaymentId", allotmentPaymentId)
    .eq("crmUserId", crmuserid)
    .range(from, to)
    .order("last_updated_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}
async function getAllotmentPaymentId(leadId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select("allotmentPaymentId")
    .eq("leadId", leadId)
    .order("last_updated_at", { ascending: false });
  if (data) {
    return data;
  } else throw error;
}
async function getCrmNotesLog(allotmentPaymentIds) {
  const { data, count, error } = await supabase
    .from("CRMNotes")
    .select("*", { count: "exact" })
    .in("allotmentPaymentId", allotmentPaymentIds)
    .order("last_updated_at", { ascending: false });
  if (data) {
    return { data, count };
  } else throw error;
}
async function getCrmLog(allotmentPaymentIds) {
  const { data, count, error } = await supabase
    .from("CRMLogs")
    .select("*", { count: "exact" })
    .in("allotmentPaymentId", allotmentPaymentIds)
    .order("created_at", { ascending: false });
  if (data) {
    return { data, count };
  } else throw error;
}

export {
  addNote,
  getNotes,
  getLeadStatus,
  addCrmNote,
  getCrmNotes,
  getAllotmentPaymentId,
  getCrmNotesLog,
  getCrmLog,
};
